(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setReveal(frame, handle, percent) {
    var clamped = clamp(percent, 0, 100);
    frame.style.setProperty('--ba-reveal-right', 100 - clamped + '%');
    handle.style.left = clamped + '%';
    frame.setAttribute('aria-valuenow', Math.round(clamped));
  }

  function percentFromClientX(frame, clientX) {
    var rect = frame.getBoundingClientRect();
    var relativeX = clientX - rect.left;
    return (relativeX / rect.width) * 100;
  }

  function initBeforeAfter(frame) {
    var handle = frame.querySelector('[data-handle]');
    if (!handle) return;

    var isDragging = false;

    function updateFromEvent(event) {
      var clientX =
        event.clientX !== undefined
          ? event.clientX
          : event.touches && event.touches[0]
          ? event.touches[0].clientX
          : null;
      if (clientX === null) return;
      setReveal(frame, handle, percentFromClientX(frame, clientX));
    }

    function onPointerDown(event) {
      isDragging = true;
      frame.setPointerCapture && frame.setPointerCapture(event.pointerId);
      updateFromEvent(event);
    }

    function onPointerMove(event) {
      if (!isDragging) return;
      updateFromEvent(event);
    }

    function onPointerUp() {
      isDragging = false;
    }

    frame.addEventListener('pointerdown', onPointerDown);
    frame.addEventListener('pointermove', onPointerMove);
    frame.addEventListener('pointerup', onPointerUp);
    frame.addEventListener('pointercancel', onPointerUp);

    // Support clavier : flèches gauche/droite pour ajuster par pas de 5%
    frame.addEventListener('keydown', function (event) {
      var current = parseFloat(frame.getAttribute('aria-valuenow')) || 50;
      if (event.key === 'ArrowLeft') {
        setReveal(frame, handle, current - 5);
        event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        setReveal(frame, handle, current + 5);
        event.preventDefault();
      }
    });

    // Position initiale
    setReveal(frame, handle, 50);
  }

  function initAll() {
    var frames = document.querySelectorAll('[data-before-after]');
    frames.forEach(initBeforeAfter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();